import { StyleSheet } from 'react-native'
import { toqueColor, white, whiteBackgroundColor } from './colors'
import { DOBRA } from './fonts'

export const buttonStyle = StyleSheet.create({
  basic: {
    borderRadius: 10,
    padding: 14,
    backgroundColor: toqueColor,
    marginTop: 20,
    width: 130,
    textAlign: 'center',
  },

  text: {
    color: whiteBackgroundColor,
    textAlign: 'center',
    fontWeight: '500',
    fontSize: 18,
    fontFamily: DOBRA,
  },

  whiteBg: {
    backgroundColor: white,
    borderColor: toqueColor,
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    justifyContent: 'center',
  },
})
